import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Logo } from "@/components/Shared";
import { ArrowLeft } from "@phosphor-icons/react";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!token) { toast.error("Invalid reset link"); return; }
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password reset. Please sign in.");
      navigate("/login", { replace: true });
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-background">
      <div className="w-full max-w-sm animate-fade-up">
        <div className="mb-8">
          <Logo height="h-20" />
        </div>
        <h1 className="text-2xl font-heading font-semibold tracking-tight">Choose a new password</h1>
        <p className="text-sm text-muted-foreground mt-1.5">Enter a new password for your account.</p>
        <form onSubmit={submit} className="space-y-4 mt-6">
          <div className="space-y-1.5">
            <Label htmlFor="password">New password</Label>
            <Input id="password" type="password" data-testid="reset-password-input" value={password} onChange={(e) => setPassword(e.target.value)} required minLength={6} className="h-11" />
          </div>
          <Button type="submit" disabled={busy} data-testid="reset-submit-button" className="w-full h-11 bg-primary hover:bg-primary/90">
            {busy ? "Resetting…" : "Reset password"}
          </Button>
        </form>
        <Link to="/login" className="inline-flex items-center gap-1.5 text-sm text-primary hover:underline mt-6">
          <ArrowLeft size={15} /> Back to sign in
        </Link>
      </div>
    </div>
  );
}
